import { render, staticRenderFns } from "./CertificateCanvas.vue?vue&type=template&id=54c26f9d&scoped=true"
import script from "./CertificateCanvas.vue?vue&type=script&lang=js"
export * from "./CertificateCanvas.vue?vue&type=script&lang=js"
import style0 from "./CertificateCanvas.vue?vue&type=style&index=0&id=54c26f9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c26f9d",
  null
  
)

export default component.exports